<template>
  <img src="/images/logos/PL_NL_V_RED_RGB.png" :alt="$t('brand-npl-logo.default.alt')" />
</template>
